export class PagedResult<T> {
    data: T[];
    total: number;
}